import { getIDFromUrl } from '@rossum/api-client';
import { CircularProgress, Stack } from '@rossum/ui/material';
import { RouteComponentProps } from 'react-router';
import { PageLayoutV2 } from '../../../../components/PageLayoutV2/PageLayoutV2';
import { useGetInbox } from '../../../../features/document-upload/hooks/useGetInbox';
import { EmailsHeader } from '../../../../features/queue-settings/headers/EmailsHeader';
import { useQueueWithWorkspace } from '../../../../features/queues/hooks/useQueueWithWorkspace';
import { EmailAddress } from '../../components/EmailAddress';
import { WorkspaceQueueBreadcrumbs } from '../../components/WorkspaceQueueBreadcrumbs';
import QueueEmailsContainer from './QueueEmailsContainer';

type QueueEmailsProps = RouteComponentProps<{ queueId: string }>;

export const QueueEmails = ({
  match: {
    url,
    params: { queueId },
  },
}: QueueEmailsProps) => {
  const { queue, workspace, workspaceIsLoading } = useQueueWithWorkspace({
    queueId: Number(queueId),
  });

  const { data: inbox, isFetching: inboxIsLoading } = useGetInbox(
    queue && queue.inbox ? getIDFromUrl(queue?.inbox) : 0
  );

  if (!queue) return null;

  return (
    <PageLayoutV2
      renderHeader={params => (
        <EmailsHeader
          parentPath={url}
          queueName={queue.name}
          scrollableDivRef={params.scrollableDivRef}
        />
      )}
    >
      {workspaceIsLoading || inboxIsLoading ? (
        <Stack
          sx={{
            width: 1,
            p: 8,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mt: 4 }}
          >
            <Stack spacing={1} sx={{ minWidth: 0 }}>
              <WorkspaceQueueBreadcrumbs
                workspace={workspace?.name}
                queue={queue.name}
              />
              <EmailAddress inboxAddress={inbox?.email} />
            </Stack>
          </Stack>
          <QueueEmailsContainer inbox={inbox} selectedQueue={queue} />
        </>
      )}
    </PageLayoutV2>
  );
};
